import { BASE_PATH } from "constants/app.mjs"
import {
  Image,
  type ImageProps,
} from "@tokenterminal/core/ui/tt-ui-image/Image"
import { cn } from "utils/cn"

interface Props extends Partial<ImageProps> {
  name: string
  logo: string
  size?: number | `${number}`
  requestSize?: number | `${number}`
}

function getClosestImageSize(size: number) {
  const sizes = [16, 32, 48, 64, 96, 128, 256, 384]

  return sizes.reduce((prev, curr) =>
    Math.abs(curr - size) < Math.abs(prev - size) ? curr : prev
  )
}

export const ProjectLogo = ({
  name,
  logo,
  size = "40",
  requestSize = "80",
  className,
  style,
  ...rest
}: Props) => {
  const searchParams = new URLSearchParams([
    ["url", "https://static1.tokenterminal.com/" + logo],
    ["w", String(getClosestImageSize(Number(requestSize)))],
    ["q", "100"],
  ])

  let projectLogo = "https://static1.tokenterminal.com/" + logo
  if (process.env.NEXT_PUBLIC_APPLICATION) {
    projectLogo = `${BASE_PATH}/_next/image?${searchParams.toString()}`
  }

  return (
    <Image
      src={projectLogo}
      width={size}
      height={size}
      alt={`${name} - Logo`}
      className={cn("transform-gpu aspect-square", className)}
      sizes={`${size}px`}
      style={{
        width: `${size}px`, // Pass size as width to Image container becasue otherwise eg. flex containers cant calculate this element's size correctly. We use flexShrink=0 here anyway so this should be fine
        ...style,
      }}
      unoptimized
      {...rest}
    />
  )
}
